import React from "react";
import { Grid } from "@mui/material";
import LabeledSelect from "../../../Widgets/LabeledSelect";
import {
  CurrentCommunicationFormValues,
  COMMUNICATION_MODALITY_OPTIONS,
  COMMUNICATION_PROFICIENCY_OPTIONS,
  COMMUNICATION_FUNCTION_LEVEL_OPTIONS,
} from "./interface";

interface EditFieldsProps {
  formValues: CurrentCommunicationFormValues;
  handleChange: (
    field: keyof CurrentCommunicationFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={6}>
      <LabeledSelect
        label="Primary Communication Modality"
        value={formValues.primaryCommunicationModality}
        onChange={handleChange("primaryCommunicationModality")}
        options={COMMUNICATION_MODALITY_OPTIONS}
        placeholder="Please select"
        helperText="How does the client typically communicate with others?"
      />
      <LabeledSelect
        label="Communication Proficiency"
        value={formValues.communicationProficiency}
        onChange={handleChange("communicationProficiency")}
        options={COMMUNICATION_PROFICIENCY_OPTIONS}
        placeholder="Please select"
        helperText="What best represents the level of complexity and independence with which the client currently communicates?"
      />
      <LabeledSelect
        label="Communication Function Level"
        value={formValues.communicationFunctionLevel}
        onChange={handleChange("communicationFunctionLevel")}
        options={COMMUNICATION_FUNCTION_LEVEL_OPTIONS}
        placeholder="Please select"
        helperText="What best describes the range of verbal operants within the client's current communication repertoire?"
      />
    </Grid>
  );
};

export default EditFields;
